import React from 'react';
import PropTypes from 'prop-types';
import jMoment from 'components/classes/Jmomen';
import Field from 'components/common/Field';
import {Card, Row, Col, Form as AntdForm, Input, Radio, Select, Button} from 'antd';
import {connect} from 'react-redux';
import {checkFile} from '../Module';


@autobind
/**
 *
 */
export default class Live extends React.PureComponent {
  static propTypes = {
  };

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  /**
   *
   * @return {XML}
   */
  render() {
    let disabled = !(this.props.currentUser && this.props.currentUser.taInfo && this.props.currentUser.taInfo.identificationCode );
    const {loading} = this.state;
    return (
      <Card
        className="wrapper"
        style={{
          width: 'calc(100% - 16px)',
          margin: '0 8px',
        }}
        title={app.translate('routes.home.guardian.Live')}
      >

        <Row
  
          style={{
            margin: 0,
            marginBottom: 16,
            height: 'calc(100% - 20px)',
          }}
        >
          123456
        </Row>
      </Card>
    );
  }
}
